module.exports = __webpack_public_path__ + "img/info.62396a9e.svg";